import styled, { css } from '../../styled';
export default styled.div `
  display: flex;
  justify-content: space-between;
  padding-left: ${({ isSubTab }) => (isSubTab ? 1.5 : 0.75)}rem;
  padding-right: 0.5rem;
  align-items: center;
  background-color: ${({ theme, isActived, bgColor, bgActiveColor }) => theme.colors[isActived ? bgActiveColor : bgColor]};
  transition: background-color 0.3s;

  ${({ theme, isActived }) => isActived &&
    css `
      & > div:first-child span {
        color: ${theme.colors.SNOW_100};
      }
    `};

  ${({ theme, iconHoverColor }) => iconHoverColor &&
    css `
      &:hover {
        svg path {
          fill: ${theme.colors[iconHoverColor]};
        }
      }
    `};

  ${({ theme, isActived, iconHoverColor }) => isActived &&
    iconHoverColor &&
    css `
      svg path {
        fill: ${theme.colors[iconHoverColor]};
      }
    `};

  ${({ theme, isDivider, bgHoverColor }) => isDivider
    ? css `
          padding: 0;
        `
    : css `
          cursor: pointer;

          &:hover {
            background-color: ${theme.colors[bgHoverColor]};
          }
        `};

  ${({ theme, isDivider, hoverColor }) => !isDivider &&
    hoverColor &&
    css `
      &:hover {
        & > div:first-child span {
          color: ${theme.colors[hoverColor]};
        }
      }
    `};
`;
//# sourceMappingURL=TabItem.js.map